import PropTypes from 'prop-types'

const CollectionItem = ({
  children,
  rounded,
  mark,
  hover = true,
  border = true,
  padding = true,
  additionalClass = '',
  isHighlight = false,
  ...props
}) => (
  <div
    {...props}
    className={`ctp-collection-item ${mark ? 'ctp-collection-item--mark' : ''} ${
      rounded ? 'ctp-collection-item--rounded' : ''
    } ${isHighlight ? 'ctp-collection-item--highlighted' : ''} ${
      hover && !isHighlight ? 'ctp-collection-item--hover' : ''
    } ${border ? 'ctp-collection-item--border' : ''} ${
      padding ? 'ctp-collection-item--padding' : ''
    } ${additionalClass}`}
  >
    <div className={`ctp-collection-item__inner`}>{children}</div>
  </div>
)

CollectionItem.propTypes = {
  children: PropTypes.node.isRequired,
  rounded: PropTypes.bool,
  mark: PropTypes.bool,
  hover: PropTypes.bool,
  border: PropTypes.bool,
  padding: PropTypes.bool,
  additionalClass: PropTypes.string,
  isHighlight: PropTypes.bool,
}

export default CollectionItem
